<template>
  <span class="share-alt-outlined-icon" :style="iconStyle" aria-hidden="true">
    <!-- 与 Ant Design ShareAltOutlined 一致（项目未装 @ant-design/icons-vue，用内联 SVG） -->
    <svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor">
      <path
        d="M752 664c-28.5 0-54.8 10-75.4 26.7L469.4 540.8a160.68 160.68 0 000-57.6l207.2-149.9C697.2 350 723.5 360 752 360c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120c0 11.6 1.6 22.7 4.7 33.3L439.9 415.8C410.7 380.2 364.5 360 312 360c-88.4 0-160 71.6-160 160s71.6 160 160 160c52.5 0 98.7-20.2 127.9-55.8l196.8 142.5c-3.1 10.6-4.7 21.8-4.7 33.3 0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120zm0-476c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zM312 600c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80zm440 236c-28.7 0-52-23.3-52-52s23.3-52 52-52 52 23.3 52 52-23.3 52-52 52z"
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'ShareAltOutlinedIcon',
  props: {
    size: { type: [Number, String], default: 16 },
  },
  computed: {
    iconStyle() {
      const px = typeof this.size === 'number' ? `${this.size}px` : this.size
      return { fontSize: px }
    },
  },
}
</script>

<style scoped>
.share-alt-outlined-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  vertical-align: middle;

  svg {
    display: block;
  }
}
</style>
